import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  enrolledIds: [],
  savedIds: [],
};

const enrollmentSlice = createSlice({
  name: 'enrollment',
  initialState,
  reducers: {
    toggleEnrollment(state, action) {
      const id = action.payload;
      if (state.enrolledIds.includes(id)) {
        state.enrolledIds = state.enrolledIds.filter((i) => i !== id);
      } else {
        state.enrolledIds.push(id);
      }
    },
    toggleSaved(state, action) {
      const id = action.payload;
      if (state.savedIds.includes(id)) {
        state.savedIds = state.savedIds.filter((i) => i !== id);
      } else {
        state.savedIds.push(id);
      }
    },
    clearEnrollments(state) {
      state.enrolledIds = [];
    },
  },
});

export const { toggleEnrollment, toggleSaved, clearEnrollments } = enrollmentSlice.actions;

export const selectEnrolledIds = (state) => state.enrollment.enrolledIds;
export const selectSavedIds = (state) => state.enrollment.savedIds;
export const selectEnrolledCount = (state) => state.enrollment.enrolledIds.length;

export default enrollmentSlice.reducer;